import { createAction } from '../../../../store.model';
import { BlDocument, BlFocus } from '../../core';
import { ActionType } from '../bl-dialog.action';

export interface ListDocuments {
    focus: BlFocus;
}

export const listDocuments = createAction<ActionType, ListDocuments>(
    ActionType.COACHING__BL__LIST_DOCUMENTS,
);

export interface ListDocumentsResult extends ListDocuments {
    documents?: BlDocument[];
}

export const listDocumentsResult = createAction<
    ActionType,
    ListDocumentsResult
>(ActionType.COACHING__BL__LIST_DOCUMENTS_RESULT);
